import { BILLING_FIELD_LAYOUTS } from '../constants/billing'
import {
  BILLING_KEY_TRANSLATION,
  BILLING_FIELD_TO_ACTIVE_KEY,
  BILLING_FIELD_TO_CUSTOM_KEY
} from '../constants/translation'

export const getBillingFieldWidthClass = (index, totalCount) => {
  const layout = BILLING_FIELD_LAYOUTS[totalCount] || ['full']
  return (layout[index] ?? 'full') === 'half' ? 'w-[49%]' : 'w-full'
}

export const getBillingFieldName = (fieldKey, customBillingNames) => {
  const customKey = BILLING_FIELD_TO_CUSTOM_KEY[fieldKey]
  const customValue = customBillingNames?.[customKey]
  if (customValue) return customValue
  return BILLING_KEY_TRANSLATION[fieldKey]
}

export const isFieldActive = (key, activeBillingFields) => {
  if (!activeBillingFields) return true
  const activeKey = BILLING_FIELD_TO_ACTIVE_KEY[key]
  return !activeKey || activeBillingFields[activeKey]
}
